import assetPath from '/opt/actions-runner/_work/crate/crate/packages/lebenslauf/articles/src/assets/alles-was-du-ueber-anlagen-in-der-bewerbung-wissen-musst.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')